// src/components/Button.jsx
import React from "react";
import { Link } from "react-router-dom";

/**
 * Button component
 *
 * Props:
 * - children:      label or inner content
 * - to?:           if provided, renders a <Link> instead of <button>
 * - onClick?:      click handler (ignored if `to` is set)
 * - variant?:      "primary" | "secondary"  (defaults to "primary")
 * - size?:         "sm" | "md" | "lg"       (defaults to "md")
 * - className?:    additional Tailwind classes
 */
export default function Button({
  children,
  to,
  onClick,
  variant = "primary",
  size = "md",
  className = "",
  ...rest
}) {
  const baseStyles = "font-regular rounded transition ";
  const variants = {
    primary: " text-red-600 hover:bg-gray-100",
    secondary: "border border-white text-white hover:bg-red-700",
  };
  const sizes = {
    sm: "px-3 py-1 text-sm",
    md: "px-4 py-2 text-base",
    lg: "px-6 py-3 text-lg",
  };

  const classes = [baseStyles, variants[variant], sizes[size], className].join(
    " ",
  );

  if (to) {
    return (
      <Link to={to} className={classes} {...rest}>
        {children}
      </Link>
    );
  }

  return (
    <button onClick={onClick} className={classes} {...rest}>
      {children}
    </button>
  );
}
